import React from 'react'

import * as S from './note-textarea.styled'

export type NoteTextareaProps = Omit<
  React.TextareaHTMLAttributes<HTMLTextAreaElement>,
  'onChange'
> & {
  label: string
  placeholder?: string
  maxLength: number
  value: string
  onChange: (value: string) => void
}

export const NoteTextarea = ({
  label,
  placeholder,
  maxLength,
  value,
  onChange,
  ...rest
}: NoteTextareaProps) => {
  const isLimitExceeded = value.length > maxLength

  return (
    <S.Container>
      <S.Label data-invalid={isLimitExceeded}>{label}</S.Label>
      <S.Textarea
        {...rest}
        aria-invalid={isLimitExceeded}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      <S.Counter data-exceeded={isLimitExceeded}>
        {value.length}/{maxLength}
      </S.Counter>
    </S.Container>
  )
}
